import styled from "styled-components";

export const DrawerHeader = styled.div``;

export const SplitDrawerContent = styled.div`
  .ant-input-affix-wrapper-lg {
    border: 0rem solid #e8eaee;
  }
  .ant-input-affix-wrapper {
    /*background: #f7f8f9;*/
    border-color: #d9e5ed;
    .ant-input {
      background: #f7f8f9;
      color: #869dad;
      font-size: 1.4rem;

      &::placeholder {
        color: #869dad;
      }
    }
  }
  .ant-collapse {
    border: none;
    .ant-collapse-item {
      background: white;
      border-color: #eaf1f4;

      .ant-collapse-header {
        padding: 1.5rem;
        padding-right: 4rem;
        color: #365366;
        font-size: 1.4rem;
        font-family: "Roboto";
        font-weight: var(--font-weight-large);
        border-radius: 0;
      }
      .ant-collapse-content {
        border-color: #eaf1f4;
        .ant-checkbox-wrapper {
          font-family: "Roboto";
          color: #365366;
          font-size: 1.4rem;
        }
      }
    }
  }
  .ant-picker-range {
    width: 100%;
  }
  .ant-collapse-header {
    padding: 1.5rem;
    padding-right: 4rem;
    color: #365366;
    font-size: 1.4rem;
    font-family: "Roboto";
    border-radius: 0;
  }
`;

export const CustomDrawerContent = styled.div`
  .ant-input-affix-wrapper {
    background: #f7f8f9;
    .ant-input {
      background: #f7f8f9;
      &::placeholder {
        color: #869dad;
      }
    }
  }
  .ant-collapse {
    border: none;
    .ant-collapse-item {
      background: white;
    }
  }
  .ant-picker-range {
    width: 100%;
  }
`;

export const FilterDrawerContent = styled.div`
  .ant-input-affix-wrapper {
    background: #f7f8f9;
    border-color: #d9e5ed;
    .ant-input {
      background: #f7f8f9;
      color: #869dad;
      font-size: 1.4rem;

      &::placeholder {
        color: #869dad;
      }
    }
  }
  .ant-collapse {
    border: none;
    .ant-collapse-item {
      background: white;
      border-color: #eaf1f4;

      .ant-collapse-header {
        padding: 1.5rem;
        padding-right: 4rem;
        color: #365366;
        font-size: 1.4rem;
        font-family: "Roboto";
        font-weight: var(--font-weight-large);
        border-radius: 0;
      }

      .ant-collapse-content {
        border-color: #eaf1f4;
        .ant-radio-wrapper,
        .ant-checkbox-wrapper {
          font-family: "Roboto";
          color: #365366;
          font-size: 1.4rem;
        }
      }
    }
  }
  .ant-picker-range {
    width: 100%;
  }
  .ant-collapse-header {
    padding: 1.5rem;
    padding-right: 4rem;
    color: #365366;
    font-size: 1.4rem;
    font-family: "Roboto";
    border-radius: 0;
  }
`;

export const Wrapper = styled.div`

	.nav-item {
		border: none;
		border-top: 0.5rem solid transparent;
		&.active {
			border-top: 0.5rem solid #1c8bf9;
		}
	}
	.tab-content {
		background: white;
	}
	.WorkSheet_tabs > .ant-tabs-nav {
		margin: 0;
		position: sticky;
		z-index: 2;
		top: 0;
		background-color: #F5F6F8;
		
	}
	.ant-tabs {
	    overflow: unset;
		
		.ant-tabs-tab-btn {
			text-transform: capitalize;
			color: #3B5175;
		}
		.ant-tabs-nav {

			.ant-tabs-tab {
				border-radius: 1.2rem 1.2rem 0rem 0rem;
				display: flex;
				justify-content: space-between;
				background-color:transparent;
			}
			.ant-tabs-tab.ant-tabs-tab-active{
				&:before {
					position: absolute;
					content: "";
					width: 2.6rem;
					height: 2.6rem;
					right: -2.4rem;
					border-radius: 50%;
					background-color: transparent;
					bottom: -0.1rem;
					box-shadow: 0.2rem 0.3rem var(--locobuzz-primary-bg-color);
					transform: rotate(80deg);
					transition: all 0.9s ease-in;
					z-index:-1;
				}
				&:after {
					position: absolute;
					content: "";
					width: 2.6rem;
					height: 2.6rem;
					left: -2.5rem;
					border-radius: 50%;
					background-color: transparent;
					bottom: -0.2rem;
					box-shadow: 0.2rem 0.3rem var(--locobuzz-primary-bg-color);
					transform: rotate(351deg);
					transition: all 0.9s ease-in;
			}
		}
	}
`;

export const BlueDiv = styled.div`
  .welcome_heading-main {
    font-size: 2.2rem;
    font-weight: var(--font-weight-large-600);
    line-height: normal;
    margin-bottom: 0.8rem;
    color: #3b5175;
    font-family: "Roboto Slab";
  }
  .welcome_heading-two {
    font-size: 1.4rem;
    line-height: 2.2rem;
    margin-bottom: 1.5rem;
    color: #5e708d;
    font-family: "Roboto";
  }

  .select-wrapper.welcome_Select {
    max-width: 66rem;
    margin: 0 auto;
    .portlet-input {
      width: 100%;
      padding: 1.5rem;
      background-image: url(../assets/search_icon.svg);
    }
    .welcome_search {
      position: absolute;
      right: 0.4rem;
      top: 1.1rem;
      cursor: pointer;
    }
    .portlet-label {
      display: none;
    }
    .ant-select-single:not(.ant-select-customize-input) {
      .ant-select-selector {
        width: 100%;
        height: 5rem !important;
        border: 0.1rem #d9e5ed solid;
        border-radius: 0.4rem;
        text-align: left;
      }
    }
    .SearchOutlined {
      font-size: 2rem;
      color: #869dad;
      font-weight: var(--font-weight-large-800);
    }
    .ant-select-arrow {
      width: auto;
      height: auto;
      top: 45%;
      cursor: default;
    }
    .ant-select-selection-search-input {
      font-size: 1.4rem;
      color: #869dad;
      height: 4.8rem !important;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 4.8rem !important;
      font-size: 1.4rem;
      color: #869dad;
    }
  }
`;

export const WorkDiv = styled.div`
  background: white;
  padding: 3.2rem 0;
  display: flex;
  justify-content: space-evenly;

  .main-div {
    width: 30%;
    .heading {
      font-size: 1.8rem;
      font-weight: var(--font-weight-large);
      color: rgb(54, 83, 102);
      font-family: "Roboto";
      margin-bottom: 1rem;
    }
  }
`;

export const AttributeBar = styled.div`
  .left {
    .ant-select-selector {
      background: #f2f7f9;
    }
  }

  .right {
    width: 25%;
  }

  .right,
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      margin: 1rem;
    }
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .ant-input {
      width: 20rem;
    }
  }
  .custom-attribute-btn {
    color: #185edf;
    border: 0.1rem solid #185edf;
    border-radius: 0.4rem;
    height: auto;
    padding: 0.55rem 1rem;
    line-height: normal;
    font-size: 1.4rem;
    font-weight: var(--font-weight-large);
    &:hover {
      color: white;
      background: #185edf;
    }
  }
  .grey-btn {
    background: #fff;
    padding: 0.8rem 1rem;
    height: auto;
    font-size: 1.4rem;
    border: 0.1rem #d9e5ed solid;
    border-radius: 0.4rem;
    color: #365366;
    width: auto;

    img {
      max-width: 1.5rem;
      max-height: 1.5rem;
    }

    &:hover {
      color: #365366;
    }
  }
`;
